// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-sett-section {
  padding: 2rem;
  background: #f4f6f8;
  color: #334155;
}
.label-sett-section .label-sett-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 2rem;
  text-align: center;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.settings-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}
.settings-card .card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}

.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.toggle-row label {
  font-weight: 500;
  color: #475569;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #004A9A;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}
.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px #004A9A;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c4c4c4;
  transition: 0.4s;
  border-radius: 34px;
}
.toggle-switch .toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.list-editor-container {
  margin-top: 1rem;
}
.list-editor-container label {
  display: block;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.5rem;
}

.list-input-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.list-input-row input {
  flex: 1 1;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 0.95rem;
  background: #f9fafb;
}
.list-input-row input:focus {
  outline: none;
  border-color: #3a86ff;
  box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);
}
.list-input-row input::placeholder {
  color: #94a3b8;
}
.list-input-row .add-item-btn {
  background: #10b981;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.list-input-row .add-item-btn:hover:not(:disabled) {
  background: #059669;
}
.list-input-row .add-item-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

.items-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 200px;
  overflow-y: auto;
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f9fafb;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.list-item .item-name {
  font-weight: 500;
  color: #475569;
}
.list-item .remove-item-btn {
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 600;
  transition: background-color 0.2s;
}
.list-item .remove-item-btn:hover:not(:disabled) {
  background: #dc2626;
}
.list-item .remove-item-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}
.action-buttons .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.action-buttons .cancel-btn:hover {
  background: #e2e8f0;
}
.action-buttons .save-btn {
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.action-buttons .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.action-buttons .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .label-sett-section {
    padding: 1rem;
  }
  .action-buttons {
    flex-direction: column;
  }
  .list-input-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/LabelSettings/LabelSettings.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EAEA,cAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AAFF;AAIE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AAFJ;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAHF;AAKE;EACE,gBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAJF;AAME;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAJJ;AAMI;EACE,yBAAA;AAJN;AAOI;EACE,2BAAA;AALN;AAQI;EACE,2BAAA;AANN;AAUE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AARJ;AAUI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AARN;;AAaA;EACE,gBAAA;AAVF;AAYE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAVJ;;AAcA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAXF;AAaE;EACE,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAXJ;AAaI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAXN;AAcI;EACE,cAAA;AAZN;AAgBE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAdJ;AAgBI;EACE,mBAAA;AAdN;AAiBI;EACE,mBAAA;EACA,mBAAA;AAfN;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAjBF;AAmBE;EACE,gBAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;AAqBI;EACE,mBAAA;EACA,mBAAA;AAnBN;;AAwBA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AArBF;AAuBE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AArBJ;AAuBI;EACE,mBAAA;AArBN;AAyBE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAvBJ;AAyBI;EACE,mBAAA;AAvBN;AA0BI;EACE,mBAAA;EACA,mBAAA;AAxBN;;AA8BA;EACE;IACE,aAAA;EA3BF;EA8BA;IACE,sBAAA;EA5BF;EA+BA;IACE,sBAAA;IACA,WAAA;EA7BF;AACF","sourcesContent":["// LabelSettings.scss - Updated to match InvoiceSettings design\n.label-sett-section {\n  padding: 2rem;\n  background: #f4f6f8;\n//   min-height: 100vh;\n  color: #334155;\n  \n  .label-sett-title {\n    font-size: 1.4rem;\n    font-weight: 600;\n    color: #004A9A;\n    margin-bottom: 2rem;\n    text-align: center;\n  }\n}\n\n.settings-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.settings-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e0e0e0;\n  \n  .card-title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #004A9A;\n    margin-bottom: 1.2rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #f1f1f1;\n  }\n}\n\n.toggle-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  \n  label {\n    font-weight: 500;\n    color: #475569;\n  }\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n  \n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n    \n    &:checked + .toggle-slider {\n      background-color: #004A9A;\n    }\n    \n    &:checked + .toggle-slider:before {\n      transform: translateX(24px);\n    }\n    \n    &:focus + .toggle-slider {\n      box-shadow: 0 0 1px #004A9A;\n    }\n  }\n  \n  .toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #c4c4c4;\n    transition: .4s;\n    border-radius: 34px;\n    \n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 22px;\n      width: 22px;\n      left: 2px;\n      bottom: 2px;\n      background-color: white;\n      transition: .4s;\n      border-radius: 50%;\n    }\n  }\n}\n\n.list-editor-container {\n  margin-top: 1rem;\n  \n  label {\n    display: block;\n    font-weight: 500;\n    color: #475569;\n    margin-bottom: 0.5rem;\n  }\n}\n\n.list-input-row {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  \n  input {\n    flex: 1;\n    padding: 0.75rem;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    background: #f9fafb;\n    \n    &:focus {\n      outline: none;\n      border-color: #3a86ff;\n      box-shadow: 0 0 0 3px rgba(58, 134, 255, 0.1);\n    }\n    \n    &::placeholder {\n      color: #94a3b8;\n    }\n  }\n  \n  .add-item-btn {\n    background: #10b981;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 0 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    \n    &:hover:not(:disabled) {\n      background: #059669;\n    }\n    \n    &:disabled {\n      background: #c4c4c4;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.list-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background: #f9fafb;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  \n  .item-name {\n    font-weight: 500;\n    color: #475569;\n  }\n  \n  .remove-item-btn {\n    background: #ef4444;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    width: 26px;\n    height: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 1.2rem;\n    font-weight: 600;\n    transition: background-color 0.2s;\n    \n    &:hover:not(:disabled) {\n      background: #dc2626;\n    }\n    \n    &:disabled {\n      background: #c4c4c4;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  \n  .cancel-btn {\n    background: #f1f1f1;\n    color: #475569;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 0.75rem 1.5rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    \n    &:hover {\n      background: #e2e8f0;\n    }\n  }\n  \n  .save-btn {\n    background: #004A9A;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 0.75rem 1.5rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    \n    &:hover:not(:disabled) {\n      background: #003a7a;\n    }\n    \n    &:disabled {\n      background: #c4c4c4;\n      cursor: not-allowed;\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .label-sett-section {\n    padding: 1rem;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n  }\n  \n  .list-input-row {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
